import { Skeleton, Stack } from "@mui/material";
import React from "react";

const TableHook = ({ header = [], tableData = [], loading = false }) => {
    return (
        <div className="profile-table-main is-desktop">
            <table className="profile-table mt-3">
                <thead className="t-head">
                    <tr>
                        {header.map((head, index) => (
                            <th key={index} className={head.sort ? "sort-header" : ""}>
                                {head.label}
                                <span>{head.icon}</span>
                            </th>
                        ))}
                    </tr>
                </thead>
                {loading ? (
                    <tbody>
                        {Array.from({ length: 4 }).map((_, rowIndex) => (
                            <tr key={rowIndex}>
                                {header.map((_, colIndex) => (
                                    <td key={colIndex}>
                                        <Stack>
                                            <Skeleton sx={{ marginTop: "10px" }} variant="rounded" height={40} />
                                        </Stack>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                ) : tableData.length > 0 ? (
                    <tbody>
                        {tableData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((data, colIndex) => (
                                    <td key={colIndex}>{data}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                ) : (
                    <tbody>
                        <tr>
                            <td colSpan={header.length}>
                                <div className="d-flex justify-content-center my-auto fw-bold pb-5">No Data found.</div>
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    );
};

export default TableHook;
